import { render, staticRenderFns } from "./Upzz.vue?vue&type=template&id=b7df63c0&scoped=true"
import script from "./Upzz.vue?vue&type=script&lang=js"
export * from "./Upzz.vue?vue&type=script&lang=js"
import style0 from "./Upzz.vue?vue&type=style&index=0&id=b7df63c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7df63c0",
  null
  
)

export default component.exports